import InterpretationInterface from './interpretation-interface';

class FanduelInterpretation implements InterpretationInterface {
    interpretPlayerExternalId(content: string): string {
        const [id] = content.split(':');

        return id.trim();
    }
}

export default FanduelInterpretation;
